import { LoginCommercialResponse } from '../../../../../types/api/endpoints/auth/loginCommercial.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { LoginCommercialFormSchema } from './LoginCommercialForm.types';

const PREFIX = '[loginCommercialQuery]';

export const LOGIN_COMMERCIAL_QUERY_KEY = 'LOGIN_COMMERCIAL';

export const loginCommercialQuery = async ({ email, password }: LoginCommercialFormSchema) => {
  console.log(PREFIX, `Requesting commercial login...`);
  const response = await AUTH_ENDPOINTS.loginCommercial({ email, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commercial login response.`);
  return json as LoginCommercialResponse;
};
